import { render, staticRenderFns } from "./oa.vue?vue&type=template&id=ac34ce4a&scoped=true"
import script from "./oa.vue?vue&type=script&lang=js"
export * from "./oa.vue?vue&type=script&lang=js"
import style0 from "./oa.vue?vue&type=style&index=0&id=ac34ce4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac34ce4a",
  null
  
)

export default component.exports